import { render } from "./SkyWorkBotSettings.vue?vue&type=template&id=4b36ea04"
import script from "./SkyWorkBotSettings.vue?vue&type=script&lang=js"
export * from "./SkyWorkBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__